import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { CAR_TYPE, DBB_STATUSES, STATUS_IDENTIFIERS, STATUS_OVERRIDE_TYPES } from "models";
import { BackordersDashboardQueryKeys } from "modules/BackordersDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { Appointment, AppointmentNote } from "models";

// TODO: wtf is this, clean up
const constructedAppointment: Appointment = {
  id: -1,
  created_on: new Date().toISOString(),
  updated_on: new Date().toISOString(),
  dms_nr: "",
  dms_created_at: new Date().toISOString(),
  wo_nr: "",
  importer_version: "",
  car_check_started: false,
  customer_waiting: false,
  customer_waiting_edited: false,
  is_local: false,
  is_money: false,
  is_star: false,
  is_star_color: "",
  is_shop: false,
  is_shop_color: "",
  is_lease_company: false,
  has_extra_check: false,
  car_check_paused_at: null,
  final_check_has_remarks: false,
  is_recurring: false,
  warranty_pin_count: 0,
  warranty_pin_signature_missing_count: 0,
  warranty_pin_claim_nr_missing_count: 0,
  warranty_pin_support_nr_missing_count: 0,
  recall_pin_count: 0,
  recall_pin_claim_nr_missing_count: 0,
  recall_pin_support_nr_missing_count: 0,
  remark_pin_count: 0,
  next_date: null,
  predicted_next_date: null,
  time_car_app: "",
  is_pinned: false,
  is_pinned_manually: false,
  status_override: STATUS_OVERRIDE_TYPES.None,
  car_in_shop: null,
  car_in_shop_edited: false,
  car_out_of_shop: null,
  car_out_of_shop_edited: false,
  due_in: null,
  car_return_time: null,
  car_return_time_edited: false,
  dms_billed_updated: false,
  check_in_com_sent: false,
  check_in_com_answered: false,
  check_in_com_to_handle: 0,
  last_dms_update: null,
  last_dms_refresh: "",
  last_dbb_refresh: "",
  last_ocw_refresh: null,
  last_recall_refresh: "",
  internal: false,
  has_panic: false,
  is_tyre_motion_ai_scanned: false,
  created_by: "",
  is_ocw_intervention_created: false,
  key_dropped_at: null,
  key_dropped_in: null,
  key_picked_up_at: null,
  key_picked_up_by_id: null,
  key_dropped_back_at: null,
  key_dropped_back_by_id: null,
  key_dropped_back_in: null,
  key_picked_up_back_at: null,
  key_picked_up_back_by_id: null,
  acses_key_drop_object_id: null,
  acses_key_drop_booking_id: null,
  acses_key_drop_in: "",
  acses_key_dropped_at: null,
  acses_key_pick_up_booking_id: null,
  acses_key_pick_up_by_id: null,
  acses_key_picked_up_at: null,
  acses_key_drop_back_object_id: null,
  acses_key_drop_back_booking_id: null,
  acses_key_drop_back_by_id: null,
  acses_key_drop_back_in: "",
  acses_key_dropped_back_at: null,
  acses_key_pick_up_back_booking_id: null,
  acses_key_assist_pick_up_booking_id: null,
  acses_key_assist_pick_up_by_id: null,
  acses_key_picked_up_back_at: null,
  sharebox_key_dropped_at: null,
  sharebox_key_dropped_in_cabinet_id: null,
  sharebox_key_dropped_in_reservation_id: null,
  sharebox_key_dropped_in_locker_no: null,
  sharebox_key_dropped_in_location: null,
  sharebox_key_picked_up_at: null,
  sharebox_key_picked_up_by_id: null,
  sharebox_key_dropped_back_at: null,
  sharebox_key_dropped_back_by_id: null,
  sharebox_key_dropped_back_in_cabinet_id: null,
  sharebox_key_dropped_back_in_receiver_id: null,
  sharebox_key_dropped_back_in_reservation_id: null,
  sharebox_key_dropped_back_in_locker_no: null,
  sharebox_key_dropped_back_in_location: null,
  sharebox_key_picked_up_back_at: null,
  sharebox_key_picked_up_back_by_id: null,
  kiosk_checked_in_at: null,
  kiosk_label_number: null,
  planning_mechanic_id: null,
  planning_work_start: null,
  planning_work_stop: null,
  has_plan_it_data: false,
  has_recalls_data: 0,
  has_ovis_data: false,
  customer_owner_name: "",
  customer_owner_profile_picture: "",
  assigned_mechanic: null,
  assigned_mechanic_order: null,
  last_assigned_mechanic: null,
  extra_parts_list_id: null,
  extra_car_check_id: null,
  appointment_status_id: 0,
  customer_driver_id: null,
  customer_owner_id: null,
  customer_contract_id: null,
  dealer_location_id: 0,
  car_id: 0,
  vehicle_type: CAR_TYPE.Unknown,
  vin_nr: "",
  car_model: "",
  car_make: "",
  reg_number: "",
  reg_number_escaped: "",
  current_km: 0,
  dms_km: 0,
  next_km: 0,
  car_apk_date: null,
  car_hu_date: null,
  driver_initials: "",
  driver_title: "",
  driver_firstname: "",
  driver_surname: "",
  contractor_initials: "",
  contractor_title: "",
  contractor_firstname: "",
  contractor_surname: "",
  owner_initials: "",
  owner_title: "",
  owner_firstname: "",
  owner_surname: "",
  company: "",
  appointment_status_identifier: STATUS_IDENTIFIERS.BackOrder,
  last_timestamp: null,
  last_user: "",
  last_user_profile_picture: "",
  last_user_at: null,
  num_approved_items_not_fixed: 0,
  has_dbb: false,
  dbb_appointment_date: null,
  car_check_dbb_status: DBB_STATUSES.NoDBBStatus,
  car_check_dbb_status_reason: "",
  final_car_check_dbb_status: DBB_STATUSES.NoDBBStatus,
  final_car_check_dbb_status_reason: "",
  dbb_file_reference: "",
  dbb_state: "",
  car_check_initiator_name: "",
  car_check_initiator_email: "",
  last_receptionist_name: "",
  last_receptionist_profile_picture: "",
  last_customer_ok_set_by_id: null,
  last_car_ready: null,
  fleet_number: "",
  acses_customer_communication: null,
  driver_opted_out_from_importing: false,
  owner_opted_out_from_importing: false,
  contractor_opted_out_from_importing: false,
  bar_code: "",
  three_department_receptionist_set_at: null,
  three_department_receptionist_user_id: null,
  three_department_parts_set_at: null,
  three_department_parts_user_id: null,
  three_department_workshop_set_at: null,
  three_department_workshop_user_id: null,
  three_department_remark: "",
  three_department_remark_user_id: null,
  three_department_remark_updated_at: null,
  three_department_parts: false,
  three_department_receptionist: false,
  three_department_workshop: false,
  xentry_job_id: ""
};

export const useBackordersDashboardListeners = () => {
  const listeners = useMemo(() => {
    const appointmentListeners: WebSocketMessageListener<Appointment>[] = [
      {
        model: "Appointment",
        action: "upsert",
        callback: ({ data }) => {
          const backordersData = typedQueryClient.getQueryData(BackordersDashboardQueryKeys.backorders);
          if (!backordersData?.items?.length) return;

          const appointmentIdx = backordersData.items.findIndex(backorder => backorder.id === data.id);
          const isBackorder = data.appointment_status_identifier === STATUS_IDENTIFIERS.BackOrder;

          let backordersItems: Appointment[] | null = null;

          if (appointmentIdx >= 0) {
            isBackorder
              ? (backordersItems = backordersData.items.with(appointmentIdx, { ...data, ...backordersData.items[appointmentIdx] }))
              : (backordersItems = backordersData.items.toSpliced(appointmentIdx, 1));
          } else if (isBackorder) backordersItems = [data, ...backordersData.items];

          if (!backordersItems) return;

          typedQueryClient.setQueryData(BackordersDashboardQueryKeys.backorders, { ...backordersData, items: backordersItems });
        }
      }
    ];

    const appointmentNoteListeners: WebSocketMessageListener<AppointmentNote>[] = [
      {
        model: "AppointmentNote",
        action: "upsert",
        callback: ({ data }) => {
          const backordersData = typedQueryClient.getQueryData(BackordersDashboardQueryKeys.backorders);
          if (!backordersData?.items?.length) return;

          const appointmentIndex = backordersData.items.findIndex(item => item.id === data.appointment_id);

          if (appointmentIndex === -1) {
            typedQueryClient.setQueryData(BackordersDashboardQueryKeys.backorders, {
              ...backordersData,
              items: [{ ...constructedAppointment, id: data.appointment_id, notes: [data] }, ...backordersData.items]
            });
          }
        }
      }
    ];

    return [...appointmentListeners, ...appointmentNoteListeners];
  }, []);

  return listeners;
};
